<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_site_form_editTitle')
        : $t('label_essweb_site_form_viewTitle')
    "
    widthClass="max-1000"
    :delBtn="hasBtn('delete-admin-site-management')"
    backgroundClass="white"
    :editBtn="!iSEdited && hasBtn('edit-admin-site-management')"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_site_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="from" lazy-validation>
        <v-row align="center" justify="start" class="white lighten-5">
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="siteData.site_name"
              @change="
                (valueArr) => {
                  siteData.site_name = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_siteNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="3" md="3" lg="3" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="siteData.site_abbr"
              @change="
                (valueArr) => {
                  siteData.site_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_siteAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="3" md="3" lg="3" cols="12">
            <normalInputTextFiled
              :maxlength="100"
              :filled="iSEdited"
              :readonly="!iSEdited"
              v-model="siteData.site_code"
              :rules="
                $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
              "
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="siteData.site_description"
              @change="
                (valueArr) => {
                  siteData.site_description = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_descriptionLabel')"
            />
          </v-col>
        </v-row>
        <v-row>
          <!-- 地图显示，暂时废弃 -->
          <!--<div class="map-container pa-3" id="allmap" ref="allmap" v-show="false">
                 <g-map :center="[103.86438,30.68673]">
                  <g-marker
                    v-for="(item,index) in markers"
                    :key="index"
                    :center="item.center"
                    :ext_data="{index,item}"
                  ></g-marker>
                </g-map>
          </div>-->
        </v-row>
        <v-row align="center" justify="start" class="white lighten-5">
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              type="number"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :readonly="!iSEdited"
              :label="$t('label_essweb_site_form_longtitudeLabel')"
              v-model="siteData.longitude"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              type="number"
              :filled="iSEdited"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :readonly="!iSEdited"
              :label="$t('label_essweb_site_form_latitudeLabel')"
              v-model="siteData.latitude"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :readonly="!iSEdited"
              :bindData="siteData.address_line_1"
              @change="
                (valueArr) => {
                  siteData.address_line_1 = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_addressLine1Label')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :showLabel="false"
              :readonly="!iSEdited"
              :bindData="siteData.address_line_2"
              @change="
                (valueArr) => {
                  siteData.address_line_2 = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_addressLine2Label')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :showLabel="false"
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="siteData.address_line_3"
              @change="
                (valueArr) => {
                  siteData.address_line_3 = valueArr;
                }
              "
              :label="$t('label_essweb_site_form_addressLine3Label')"
            />
          </v-col>

          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              :items="allCountry"
              label="label_essweb_site_form_countryLabel"
              item-text="name"
              item-value="id"
              v-model="siteData.country_uuid"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :placeholder="$t('label_essweb_site_form_countryLabel')"
              :filled="iSEdited"
              :readonly="!iSEdited"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              :items="allCity"
              label="label_essweb_site_form_cityLabel"
              item-text="name"
              item-value="id"
              v-model="siteData.city_uuid"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :placeholder="$t('label_essweb_site_form_cityLabel')"
              :filled="iSEdited"
              :readonly="!iSEdited"
              :disabled="!siteData.country_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              :items="siteType"
              label="label_essweb_site_form_siteTypeLabel"
              item-text="site_type_name"
              item-value="uuid"
              small-chips
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              deletable-chips
              v-model="siteData.site_type_uuid"
              chips
              :readonly="!iSEdited"
              multiple
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              :filled="iSEdited"
            >
              <template v-slot:selection="{ data }">
                {{ data.item.site_type_name }}
              </template>
              <template v-slot:item.title="{ data }">
                {{ data.item.site_type_name }}
              </template>
            </AutoComplete>
          </v-col>

          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              :label="$t('label_essweb_site_form_effectiveDateLabel')"
              :filled="iSEdited"
              type="date"
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              :max="siteData.expired_utc_datetime"
              :defaultTime="siteData.effective_utc_datetime"
              placeholder="YYYY/MM/DD"
              @change="
                (time) => {
                  siteData.effective_utc_datetime = time;
                }
              "
            />
          </v-col>
          <!-- <v-col xs='12' sm="6" md="4" lg="4" cols="12">
                <v-sheet class=" text--secondary">Time Zone</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :filled="iSEdited"
              single-line
              :readonly="!iSEdited"
              dense
              v-model="siteData.effective_time_zone"
              placeholder="time zone"
            >
              <template v-slot:no-data> <noContent /> </template>
              </v-select>
          </v-col>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              :min="siteData.effective_utc_datetime"
              :defaultTime="siteData.expired_utc_datetime"
              :label="$t('label_essweb_site_form_expiredDateLabel')"
              @change="
                (time) => {
                  siteData.expired_utc_datetime = time;
                }
              "
              type="date"
              placeholder="YYYY/MM/DD"
              :filled="iSEdited"
            />
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_site_form_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              v-model="siteData.expired_time_zone"
              dense
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :filled="iSEdited"
              single-line
              :readonly="!iSEdited"
              :placeholder="$t('label_essweb_site_form_timeZoneLabel')"
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_site_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              :filled="iSEdited"
              single-line
              :readonly="!iSEdited"
              counter="500"
              dense
              v-model="siteData.remarks"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <!-- content -->
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions v-if="iSEdited" saveBtn @save="toSave" @cancel="toBack" />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main> </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "siteEdit",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "staticZone"]),
    siteType() {
      return this.$getSelectTrans(this.siteTypeData, "site_type_name");
    },
    allCountry() {
      return this.$getSelectTrans(this.allCountryData, "name");
    },
  },
  watch: {
    "siteData.country_uuid": function (val) {
      this.getAllCity();
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.getSiteType();
    this.getSiteDetailsByUuid();
    this.getAllCountry();
  },
  data() {
    return {
      iSEdited: false,
      allCountryData: [],
      allCity: [],
      maps: null,
      tab: null,
      siteData: {
        site_name: "",
        site_code: "",
        site_description: "",
        site_abbr: "",
        longitude: "",
        latitude: "",
        address_line_1: "",
        city_uuid: "",
        country_uuid: "",
        address_line_2: "",
        address_line_3: "",
        effective_utc_datetime: "",
        expired_utc_datetime: "",
        effective_time_zone: 0,
        expired_time_zone: 0,
        site_type_uuid: [],
        remarks: "",
      },
      markers: [
        // marker 集合
        {
          center: [103.86438, 30.68673], // 点位置
          icon: "https://assets.xiaokakj.com/static/img/chuzuche/dian.png", // 点图标
        },
      ],
      siteTypeData: [],
    };
  },
  methods: {
    removeType: function (item) {
      const index = this.siteData.site_type_uuid.indexOf(item.uuid);
      if (index >= 0) this.siteData.site_type_uuid.splice(index, 1);
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getSiteDetailsByUuid();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getSiteDetailsByUuid();
        } else {
          this.$router.back();
        }
      }
    },
    getSiteType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site_type",
        url: "/site-type/get-site-type-list/",
      }).then((res) => {
        that.siteTypeData = res.data;
      });
    },
    getAllCity: function () {
      const that = this;
      that.allCity = [];
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/other/get-position/",
        data: {
          level: 3,
          pid: this.siteData.country_uuid,
        },
      }).then((res) => {
        that.allCity = res.data;
        return res.data;
      });
    },
    getAllCountry: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/other/get-position/",
        data: { level: 2 },
      }).then((res) => {
        that.allCountryData = res.data;
      });
    },
    getSiteDetailsByUuid: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/get-site-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        if (res.data.site_type_uuid.indexOf(",") != -1) {
          res.data.site_type_uuid = res.data.site_type_uuid.split(",");
        } else {
          res.data.site_type_uuid = [res.data.site_type_uuid];
        }
        res.data["site_name_save"] = res.data.site_name;
        res.data.site_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.site_name
        );
        res.data["site_description_save"] = res.data.site_description;
        res.data.site_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.site_description
        );
        res.data["site_abbr_save"] = res.data.site_abbr;
        res.data.site_abbr = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.site_abbr
        );
        res.data["address_line_1_save"] = res.data.address_line_1;
        res.data.address_line_1 = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.address_line_1
        );
        res.data["address_line_2_save"] = res.data.address_line_2;
        res.data.address_line_2 = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.address_line_2
        );
        res.data["address_line_3_save"] = res.data.address_line_3;
        res.data.address_line_3 = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.address_line_3
        );
        res.data.effective_utc_datetime = this.$getDateTime(
          res.data.effective_utc_datetime,
          "YYYY-MM-DD"
        );
        res.data.expired_utc_datetime = this.$getDateTime(
          res.data.expired_utc_datetime,
          "YYYY-MM-DD"
        );
        res.data.city_uuid = Number(res.data.city_uuid);
        res.data.country_uuid = Number(res.data.country_uuid);
        that.siteData = res.data;
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/delete-site-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t("message_essweb_site_list_deleteSiteSuccessLabel"),
          type: "success",
        });
        that.toBack();
      });
    },
    toEdit: function () {
      this.iSEdited = true;
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["from"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/update-site-table/",
        data: {
          uuid: this.$route.params.id,
          site_code: this.siteData.site_code,
          site_name: this.$transCommonLangKey(
            this.siteData.site_name,
            this.siteData.site_name_save
          ),
          site_description: this.$transCommonLangKey(
            this.siteData.site_description,
            this.siteData.site_description_save
          ),
          site_abbr: this.$transCommonLangKey(
            this.siteData.site_abbr,
            this.siteData.site_abbr_save
          ),
          longitude: this.siteData.longitude,
          latitude: this.siteData.latitude,
          address_line_1: this.$transCommonLangKey(
            this.siteData.address_line_1,
            this.siteData.address_line_1_save
          ),
          address_line_2: this.$transCommonLangKey(
            this.siteData.address_line_2,
            this.siteData.address_line_2_save
          ),
          address_line_3: this.$transCommonLangKey(
            this.siteData.address_line_3,
            this.siteData.address_line_3_save
          ),
          city_uuid: this.siteData.city_uuid,
          country_uuid: this.siteData.country_uuid,
          effective_utc_datetime: this.$getTimeValue(
            this.siteData.effective_utc_datetime
          ),
          // effective_time_zone: this.siteData.effective_time_zone,//BJ
          expired_utc_datetime: this.$getTimeValue(
            this.siteData.expired_utc_datetime
          ),
          // expired_time_zone: this.siteData.expired_time_zone,//BJ
          site_type_uuid: this.siteData.site_type_uuid.join(","),
          remarks: this.siteData.remarks,
        },
      }).then((res) => {
        // that.getSiteDetailsByUuid();
        that.toBack(); //回到不能编辑状态
        that.$showMessage({
          text: that.$t("message_essweb_site_list_updateSiteSuccessLabel"),
          type: "success",
        });
      });
    },
  },
};
</script>
<style scoped>
.map-container {
  width: 100%;
  height: 400px;
}
</style>
